<template>
    <v-row class="fill-height" align="center" justify="center" >
        <v-card>
            <v-row >
                <v-col cols="12">
                    <h2 class="text-center">Login Error</h2>
                </v-col>
                <v-col cols="12">
                    <p class="text-center">There was a problem logging you in. Please try again shortly.</p>
                </v-col>
                <v-col cols="12" v-if="errorMessage">
                    <v-alert outlined :value="true" color="error" icon="error">
                        {{errorMessage}}
                    </v-alert>
                </v-col>
            </v-row>
            <v-row  class="dialog-action-buttons">
                <v-col cols="6">
                    <v-btn @click="retry()" block class="success" :loading="loading">
                        Retry
                    </v-btn>
                </v-col>
                <v-col cols="6">
                    <v-btn @click="signOut()" block class="error" :loading="loading">
                        Logout
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-row>
</template>

<script>
export default {
    data() {
        return {
            loading: false
        }
    },
    components: {

    },
    computed: {
        errorMessage: function() {
            return this.$route.query.errorMessage;
        }
    },
    methods: {
        retry() {
            this.loading = true;

            // navigate to loggingin to make sure we show a loading indicator
            // logginin will then navigate back to the home page - and since that requires permissions it will trigger the login process again
            this.$router.push({name: "loggingin"});
        },
        signOut () {
            this.$router.push({name: "logout"});
        }
    }
};
</script>